import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
import { CBcPrivilegeInfo, CBcPrivilegeOperationInfo, CBcPrivilegeElementInfo, CBcPrivilegeMenuInfo, CBcPrivilegeFileInfo, } from '@/classes/BcClasses';
class BcDialog {
    constructor() {
        this.visible = false;
        this.formValid = false;
        this.loading = false;
        this.text = '';
        this.title = '';
        this.form = new CBcPrivilegeInfo();
    }
}
class PrivilegeMethod {
}
let UserPrivilege = class UserPrivilege extends Vue {
    constructor() {
        super();
        this.list = [];
        this.listOpMethod = [];
        this.listGroup = [];
        this.listGroupSearch = null;
        this.elementTypes = [];
        this.elements = [];
        this.snackbar = new CBcSnackbar();
        this.dialog = new BcDialog();
        this.pageLoading = false;
        this.searchForm = {
            name: '',
            generalName: '',
            address: '',
            type: ''
        };
        this.typeOptions = [
            { text: '操作权限', value: 'operation' },
            { text: '元素权限', value: 'element' },
            { text: '菜单权限', value: 'menu' },
            { text: '文件权限', value: 'file' }
        ];
        this.searchTimeout = null;
        this.headers = [
            { text: '权限类别', align: 'left', width: 120, value: 'type' },
            { text: '权限名称', align: 'left', width: 120, value: 'name' },
            { text: '权限分组', align: 'left', width: 120, value: 'group' },
            { text: '权限说明', align: 'left', value: 'description' },
            { text: '操作', align: 'center', width: 120, value: 'action', sortable: false, filterable: false }
        ];
        const that = this;
    }
    mounted() {
        this.getList();
        this.getOpMethod();
        this.getPrisGroups();
        this.getElementList();
        this.getElementTypeList();
    }
    onDialogFormTypeChanged(v) {
        const that = this;
        that.dialog.form.info = /operation/i.test(v) ? new CBcPrivilegeOperationInfo(that.dialog.form.info) : /element/i.test(v) ? new CBcPrivilegeElementInfo(that.dialog.form.info) : /menu/i.test(v) ? new CBcPrivilegeMenuInfo(that.dialog.form.info) : new CBcPrivilegeFileInfo(that.dialog.form.info);
        // that.dialog.form.group = /operation|file/i.test(v) ? 'data' : /element|menu/i.test(v) ? 'fun' : 'other'
    }
    onDialogVisibleChanged(v, o) {
        const that = this;
        if (v === o)
            return;
        if (!v) {
            that.$refs.priForm.reset();
        }
    }
    getTypeName(type) {
        return /operation/i.test(type) ? '操作' : /element/i.test(type) ? '元素' : /menu/i.test(type) ? '菜单' : '文件';
    }
    getGroupName(type) {
        return /element|menu/i.test(type) ? '功能权限' : /operation|file/i.test(type) ? '数据权限' : '其他权限';
    }
    // 获取通用搜索框标签
    getGeneralSearchLabel() {
        const that = this;
        if (that.searchForm.type === 'element') {
            return '元素名称';
        }
        else if (that.searchForm.type === 'operation') {
            return '操作名称';
        }
        else {
            return '通用查询';
        }
    }
    // 获取通用搜索框占位符
    getGeneralSearchPlaceholder() {
        const that = this;
        if (that.searchForm.type === 'element') {
            return '搜索元素名称';
        }
        else if (that.searchForm.type === 'operation') {
            return '搜索操作名称';
        }
        else {
            return '搜索权限名称、元素名称或操作名称';
        }
    }
    // 获取地址搜索框标签
    getAddressSearchLabel() {
        const that = this;
        if (that.searchForm.type === 'element') {
            return '元素路由';
        }
        else if (that.searchForm.type === 'operation') {
            return 'API地址';
        }
        else {
            return '地址查询';
        }
    }
    // 获取地址搜索框占位符
    getAddressSearchPlaceholder() {
        const that = this;
        if (that.searchForm.type === 'element') {
            return '搜索元素路由地址';
        }
        else if (that.searchForm.type === 'operation') {
            return '搜索API接口地址';
        }
        else {
            return '搜索路由或API地址';
        }
    }
    async getList() {
        const that = this;
        that.pageLoading = true;
        try {
            // 构建查询参数
            const params = {};
            if (that.searchForm.name)
                params.name = that.searchForm.name;
            if (that.searchForm.generalName) {
                // 根据权限类别决定查询字段
                if (that.searchForm.type === 'element') {
                    params.elementName = that.searchForm.generalName;
                }
                else if (that.searchForm.type === 'operation') {
                    params.operationName = that.searchForm.generalName;
                }
                else {
                    // 未选择类别时，同时查询权限名称、元素名称和操作名称
                    params.name = that.searchForm.generalName;
                    params.elementName = that.searchForm.generalName;
                    params.operationName = that.searchForm.generalName;
                }
            }
            if (that.searchForm.address) {
                // 根据权限类别决定地址查询字段
                if (that.searchForm.type === 'element') {
                    params.elementPath = that.searchForm.address;
                }
                else if (that.searchForm.type === 'operation') {
                    params.operationUrl = that.searchForm.address;
                }
                else {
                    // 未选择类别时，同时查询元素路径和操作URL
                    params.elementPath = that.searchForm.address;
                    params.operationUrl = that.searchForm.address;
                }
            }
            if (that.searchForm.type)
                params.type = that.searchForm.type;
            const res = (await that.axios.get('/api/privileges', { params })).data;
            that.list = res.result || [];
            that.pageLoading = false;
        }
        catch (e) {
            that.pageLoading = false;
            console.log('error to load privileges:', e);
            that.snackbar.error('数据加载失败');
        }
    }
    async getElementTypeList() {
        const that = this;
        try {
            const res = (await that.axios.get('/api/privileges/elements/types')).data;
            that.elementTypes = (res.result || []).filter((v) => Boolean(v));
        }
        catch (e) {
            console.log('error to load privileges element types:', e);
            that.snackbar.error('数据加载失败');
        }
    }
    async getElementList() {
        const that = this;
        try {
            const res = (await that.axios.get('/api/privileges/elements')).data;
            that.elements = res.result || [];
        }
        catch (e) {
            console.log('error to load privileges elements:', e);
            that.snackbar.error('数据加载失败');
        }
    }
    async getPrisGroups() {
        const that = this;
        try {
            const res = (await that.axios.get('/api/privileges/groups')).data;
            // console.log('listGroup:', res)
            that.listGroup = (res.result || []).filter((v) => Boolean(v));
        }
        catch (e) {
            console.log('error to load privileges groups:', e);
            // that.snackbar.error('数据加载失败')
        }
    }
    async getOpMethod() {
        const that = this;
        // that.pageLoading = true
        try {
            const res = (await that.axios.get('/api/privileges/methods', { params: {} })).data;
            that.listOpMethod = res.result || [];
            // that.pageLoading = false
        }
        catch (e) {
            // that.pageLoading = false
            console.log('error to load privileges operation methods:', e);
            that.snackbar.error('权限操作方法数据加载失败');
        }
    }
    createNew() {
        const that = this;
        that.dialog.title = '新增权限';
        that.dialog.visible = true;
        // that.$nextTick(() => {
        //   if (that.$refs.priForm)that.$refs.priForm.validate()
        // })
    }
    editItem(item) {
        const that = this;
        that.dialog.title = '修改权限';
        that.dialog.visible = true;
        that.dialog.form = new CBcPrivilegeInfo(item);
    }
    deleteItem(item) {
        const that = this;
        if (that.$refs.refFormDevice)
            that.$refs.refFormDevice.resetValidation();
        that.dialog.persistent = false;
        that.dialog.editor = 3;
        that.dialog.title = '删除记录';
        that.dialog.text = `确定删除【${item && item['name'] || ''}】该权限，操作不可恢复，请确认.`;
        // that.form = new DataObject(item)
        that.dialog.visible = true;
    }
    async savePrivliege() {
        const that = this;
        const isEdit = /修改权限/i.test(that.dialog.title);
        const isDelete = /删除/i.test(that.dialog.title);
        if (!isDelete && !that.$refs.priForm.validate()) {
            that.snackbar.warn('请填写必要字段后重试.');
            return;
        }
        that.dialog.loading = true;
        try {
            if (!isDelete && /object/i.test(typeof that.dialog.form.info.method))
                that.dialog.form.info['method'] = that.dialog.form.info.method.privilege;
            const body = that.dialog.form;
            const res = await that.axios[isDelete ? 'delete' : isEdit ? 'put' : 'post']('/api/privileges/com', body);
            that.dialog.loading = false;
            that.dialog.visible = false;
            that.dialog.form = new CBcPrivilegeInfo();
            that.getList();
            that.getPrisGroups();
            that.getElementList();
            that.getElementTypeList();
        }
        catch (e) {
            that.dialog.loading = false;
            console.log('savePrivliege error:', e);
            that.snackbar.error(`权限${isDelete ? '删除' : isEdit ? '修改' : '新增'}失败:` + (e && (e.result || e.info || e.error)));
        }
    }
    // 搜索输入防抖处理
    onSearchInput() {
        const that = this;
        if (that.searchTimeout) {
            clearTimeout(that.searchTimeout);
        }
        that.searchTimeout = setTimeout(() => {
            that.handleSearch();
        }, 500);
    }
    // 执行搜索
    handleSearch() {
        const that = this;
        that.getList();
    }
    // 重置搜索条件
    handleReset() {
        const that = this;
        that.searchForm = {
            name: '',
            generalName: '',
            address: '',
            type: ''
        };
        that.getList();
    }
};
__decorate([
    Watch('dialog.form.type')
], UserPrivilege.prototype, "onDialogFormTypeChanged", null);
__decorate([
    Watch('dialog.visible')
], UserPrivilege.prototype, "onDialogVisibleChanged", null);
UserPrivilege = __decorate([
    Component({
        name: 'Privilege',
        components: {
            BcSnackbar,
        }
    })
], UserPrivilege);
export default UserPrivilege;
;
